import * as z from "zod";

export const PrintLabelShortfallSchema = z.object({
  sku: z.string(),
  available: z.number(),
  required: z.number(),
});
export type PrintLabelShortfall = z.infer<typeof PrintLabelShortfallSchema>;

export const BlockedPrintLabelGroupSchema = z.object({
  fulfillmentGroupId: z.string(),
  orderName: z.string(),
  shortfalls: z.array(PrintLabelShortfallSchema),
});
export type BlockedPrintLabelGroup = z.infer<
  typeof BlockedPrintLabelGroupSchema
>;

/**
 * Pre-flight inventory check for the "Print labels" flow (OMS-3373): returns
 * which selected fulfillment groups have stock to fulfill vs. must be held back.
 */
export const checkPrintLabelInventory = {
  name: "checkPrintLabelInventory" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({
    printableGroupIds: z.array(z.string()),
    blockedGroups: z.array(BlockedPrintLabelGroupSchema),
  }),
};
